// extracted by mini-css-extract-plugin
export default {"addPropertyBtn":"_2Zs6K4ESoUtmuyLtZDmyL7"};